export default "__VITE_ASSET__aUlDqfOq__"